import { TrendingUp, TrendingDown, Minus } from "lucide-react";

export function KpiCard({ label, value, delta, trend, onClick, testId }) {
  const Icon = trend === "up" ? TrendingUp : trend === "down" ? TrendingDown : Minus;
  const color = trend === "up" ? "text-emerald-600" : trend === "down" ? "text-red-500" : "text-slate-400";
  const Component = onClick ? "button" : "div";
  return (
    <Component
      type={onClick ? "button" : undefined}
      onClick={onClick}
      data-testid={testId}
      className={`rounded-xl border border-slate-200 bg-white p-4 ${onClick ? "w-full cursor-pointer text-left transition-colors hover:border-indigo-300 hover:bg-indigo-50/40" : ""}`}
    >
      <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-400">{label}</div>
      <div className="mt-1.5 flex items-end justify-between">
        <div className="font-display text-2xl font-bold text-slate-900 font-mono-num">{value}</div>
        {delta && (
          <div className={`flex items-center gap-1 text-xs font-semibold ${color}`}>
            <Icon className="h-3.5 w-3.5" strokeWidth={2} />
            {delta}
          </div>
        )}
      </div>
    </Component>
  );
}
